// Keyed by platformAgentName: `amigo` on FoodAmigos, `assistant` on a partner's dashboard.
export default {
  label: {
    amigo: 'Vraag het aan Amigo',
    assistant: 'Assistent',
  },
  // The button's name while it shows a count of answers the person hasn't seen (the count itself is hidden from
  // screen readers).
  label_unread: {
    amigo_one: 'Vraag Amigo, nieuw: {{count}}',
    amigo_other: 'Vraag Amigo, nieuw: {{count}}',
    assistant_one: 'Assistent, nieuw: {{count}}',
    assistant_other: 'Assistent, nieuw: {{count}}',
  },
  unavailable_label: {
    amigo: 'Amigo niet beschikbaar',
    assistant: 'Assistent niet beschikbaar',
  },
  unavailable_text: {
    amigo: 'Amigo is momenteel niet beschikbaar.',
    assistant: 'De assistent is momenteel niet beschikbaar.',
  },
};
